/**
 * Load polyfills only when required.
 * Each function checks if the polyfill is needed, then uses
 * requre.ensure to load it.
 *
 * polyfillsReady resolves when all necessary polyfills have loaded
 */

function intl () {
    return new Promise((resolve) => {
        if (!global.Intl) {
            require.ensure([
                'intl',
                'intl/locale-data/jsonp/en.js'
            ], function (require) {
                require('intl');
                require('intl/locale-data/jsonp/en-GB.js');
                resolve();
            }, 'intlPolyfill');
        } else {
            resolve();
        }
    });
}

function placeholders () {
    return new Promise((resolve) => {
        const test = document.createElement('input');
        const nativeSupport = test.placeholder !== void 0;
        if (!nativeSupport) {
            require.ensure([
                './polyfills/placeholder_polyfill'
            ], function (require) {
                require('./polyfills/placeholder_polyfill');
                resolve();
            }, 'placeholder_polyfill');
        } else {
            resolve();
        }
    });
}

function scrollIntoViewIfNeeded () {
    return new Promise((resolve) => {
        if (!Element.prototype.scrollIntoViewIfNeeded) {
            require.ensure([
                './polyfills/ScrollIntoViewIfNeeded'
            ], function (require) {
                require('./polyfills/ScrollIntoViewIfNeeded');
                resolve();
            }, 'scrollIntoViewPolyfill');
        } else {
            resolve();
        }
    });
}


export function polyfillsReady () {
    return Promise.all([intl(), placeholders(), scrollIntoViewIfNeeded()]);
}



// WEBPACK FOOTER //
// ./src/lib/Polyfills.js